import React from 'react';
import { Link } from 'react-router-dom';
import oshoLogo from '../../assets/osho-logo.png';

const AuthShell = ({ title, subtitle, children, footer }) => (
  <div className="min-h-screen bg-cream flex flex-col">
    <header className="px-6 lg:px-10 h-20 flex items-center border-b border-rose/40 bg-cream/90 backdrop-blur">
      <Link to="/" className="flex items-center" aria-label="Osho Universal home">
        <img src={oshoLogo} alt="Osho Universal" className="h-11 w-auto" />
      </Link>
    </header>

    <main className="flex-1 grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxtZWRpdGF0aW9uJTIwc3Vuc2V0fGVufDB8fHx8MTc4NDE4MjIyOHww&ixlib=rb-4.1.0&q=85)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-br from-mahogany/40 via-burgundy/30 to-transparent" />
        <div className="relative z-10 h-full flex flex-col justify-end p-12 text-cream">
          <p className="font-italic-display text-4xl leading-tight">&ldquo;Truth is not something outside to be discovered, it is something inside to be realised.&rdquo;</p>
          <p className="mt-4 tracking-widest text-sm uppercase opacity-80">— Osho</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-14">
        <div className="w-full max-w-md">
          <h1 className="font-serif-display text-4xl text-burgundy leading-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-mahogany/80">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-sm text-mahogany/80">{footer}</div>}
        </div>
      </div>
    </main>
  </div>
);

export default AuthShell;
